import React from 'react';
import ErrorContainer from './containers';
import { useTranslation } from 'react-i18next';

const Maintenance = () => {
  const { t } = useTranslation();
  return <ErrorContainer message={t('errors.maintenance')} />;
};

export default Maintenance;
